<script setup lang="ts">
interface NumberOfSlidesProps {
  currentSlide: number;
  numberOfSlides: number;
  background: 'dark-background' | 'transparent-background';
  size?: 's' | 'm';
}

const props = withDefaults(defineProps<NumberOfSlidesProps>(), {
  size: 'm',
});
</script>

<template>
  <div class="app-number-of-slides" :class="[props.background, props.size]">
    {{ `${props.currentSlide + 1} / ${props.numberOfSlides}` }}
  </div>
</template>

<style scoped lang="scss">
@import '../../styles/_fonts.scss';
.app-number-of-slides {
  color: var(--color-white);
  text-align: center;
  border-radius: var(--border-radius-8);
  overflow: hidden;
  z-index: 1;
  &.s {
    @include font-body-s-light;
    padding: var(--spacing-4) var(--spacing-8);
  }
  &.m {
    min-width: var(--spacing-64);

    @include font-label-l-bold;
    padding: var(--spacing-8);
  }
  &.dark-background {
    background-color: var(--color-overlay);
  }
  &.transparent-background {
    background-color: transparent;
  }
}
</style>
